import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'react-bootstrap';
import classNames from 'classnames';
import numeral from 'numeral';
import moment from 'moment';
import MetaTags from 'react-meta-tags';
import { bindActionCreators } from 'redux';

import LeftNav from './LeftNav';
import Loading from '../../ui/Loading';
import fetchDux from '../../../state/fetch-dux';
import MetaLoader from '../../ui/MetaLoader';

class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeOrder: ''
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);

    const {
      getOrderHistory
    } = this.props;

    getOrderHistory();

    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-my-orders',
      'page-template-page-templatesshop-template-my-account-my-orders-php',
      'page',
      'page-id-253',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-my-orders',
      'page-template-page-templatesshop-template-my-account-my-orders-php',
      'page',
      'page-id-253',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      user,
      inProgress,
      loading,
      orderHistory,
      error
    } = this.props;

    const {
      LineItems,
      PurchaseOrders,
      TipLineItems
    } = orderHistory || {};

    const orders = (PurchaseOrders || []).map(({
      POID,
      DateOrderTaken,
      EstimatedShipDate,
      OrderStatusID,
      Subtotal,
      Tax,
      Freight,
      OrderstatusName,
      TotalMarkDown,
      isPOSInvoice,
      taxDetails,
      SetCoRetailTax
    }) => {
      const items = (LineItems || [])
        .filter(item => item.PurchaseOrderID === POID);
      const numItems = (items || []).length;

      const { KitPrice: tip } = (TipLineItems || [])
        .find(({ PurchaseOrderID }) => PurchaseOrderID === POID) || {};

      return {
        POID,
        DateOrderTaken,
        EstimatedShipDate,
        OrderStatusID,
        Subtotal,
        Tax,
        Freight,
        items,
        numItems,
        OrderstatusName,
        TotalMarkDown,
        tip: tip || 0,
        isPOSInvoice,
        taxDetails,
        SetCoRetailTax
      };
    });

    const noOrders = (PurchaseOrders || []).length === 0 ? true : false;

    const scrollToTop = () => window.scrollTo(0, 0);
    const { activeOrder } = this.state;
    const toggleOrder = order =>
      this.setState({ activeOrder: order === activeOrder ? '' : order });
    return (
      <div id="content" className="site-content">
        <MetaLoader title="My Orders | Account | Twomey" />
        <MetaTags>
          <title>My Orders | Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="My Orders | Account | Twomey" />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/my-orders"
          />
        </MetaTags>
        <div id="primary" className="content-area">

          <main id="main" className="site-main account-page nohero">

            <div className="container">
              <div className="row">

                <LeftNav />

                <div className="col-products">
                  <h1 className="smaller account-header">My Orders</h1>
                  {inProgress &&
                    <div className="row product-grid">
                      <Loading message="Loading Orders" />
                    </div>}
                  {noOrders &&
                    !inProgress &&
                    !error &&
                    <h2 align="center">- No orders found -</h2>}
                  {!inProgress &&
                    error &&
                    <div
                      style={{
                        color: 'red',
                        paddingTop: '10px',
                        textAlign: 'center'
                      }}
                    >
                      - An error occurred retrieving your orders, please try again later. -
                    </div>}
                  {!inProgress &&
                    (orders || [])
                      .sort((a, b) => {
                        // sort array by date descending before mapping function
                        return new Date(b.DateOrderTaken) -
                          new Date(a.DateOrderTaken);
                      })
                      .map((order, index) => {
                        const {
                          taxDetails,
                          SetCoRetailTax
                        } = order || {};

                        const {
                          containsExciseOrWholeSale,
                          taxBreakout
                        } = taxDetails || {};

                        const {
                          SalesTax,
                          ExciseTax,
                          WholesaleTax,
                          CRVTax,
                          CODeliveryFee
                        } = taxBreakout || {};
                        return (
                          <div className="order-box" key={order.index}>
                            <div className="row order-snapshot">
                              <div className="col-md-2">
                                <p className="account-info-block">
                                  <strong>Order:</strong>
                                  {order.POID}
                                </p>
                              </div>
                              <div className="col-md-3">
                                <p className="account-info-block">
                                  <strong>Ordered on:</strong>
                                  {moment(order.DateOrderTaken).format('LL')}
                                </p>
                              </div>
                              <div className="col-md-2">
                                <p className="account-info-block">
                                  <strong>Items:</strong>
                                  {order.numItems}
                                </p>
                              </div>
                              <div className="col-md-2">
                                <p className="account-info-block">
                                  <strong>Total:</strong>
                                  {numeral(
                                    order.Subtotal +
                                      order.Tax +
                                      order.Freight -
                                      order.TotalMarkDown
                                  ).format('$0,0.00')}
                                </p>
                              </div>
                              <div className="col-md-3">
                                <p className="account-info-block">
                                  <strong>Status:</strong>
                                  {order.OrderstatusName}
                                </p>
                              </div>
                            </div>
                            <Collapse
                              className="order-details"
                              id={`order${order.POID}`}
                              in={activeOrder === order.POID}
                            >
                              <div>
                                <div className="table-responsive">
                                  <table className="table">
                                    <tbody>
                                      <tr>
                                        <th>Qty.</th>
                                        <th>Items</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                      </tr>
                                      {order.items.map((item, index) => (
                                        <tr key={item.PurchaseOrderDetailID}>
                                          <td>{item.Quantity}</td>
                                          <td>{item.Description}</td>
                                          <td>
                                            {numeral(item.KitPrice).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                          <td>
                                            {numeral(
                                              item.KitPrice * item.Quantity
                                            ).format('$0,0.00')}
                                          </td>
                                        </tr>
                                      ))}
                                      {order.TotalMarkDown > 0 &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            Discount:
                                          </td>
                                          <td>
                                            (
                                            {numeral(
                                              order.TotalMarkDown
                                            ).format('$0,0.00')}
                                            )
                                          </td>
                                        </tr>}
                                      <tr>
                                        <td colSpan="3" align="right">
                                          Shipping:
                                        </td>
                                        <td>
                                          {numeral(order.Freight).format(
                                            '$0,0.00'
                                          )}
                                        </td>
                                      </tr>
                                      {containsExciseOrWholeSale &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            {`Sales Tax:`}
                                          </td>
                                          <td>
                                            {numeral(SalesTax).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                      {containsExciseOrWholeSale &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            {`Excise Tax:`}
                                          </td>
                                          <td>
                                            {numeral(ExciseTax).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                      {containsExciseOrWholeSale &&
                                        WholesaleTax > 0 &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            {`Wholesale Tax:`}
                                          </td>
                                          <td>
                                            {numeral(WholesaleTax).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                      {!containsExciseOrWholeSale &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            Tax:
                                          </td>
                                          <td>
                                            {/* //if the order is shipped to CO, we will subtract the CO delivery fee  from total tax and show it below. */}
                                            {numeral(SetCoRetailTax ? order.Tax-CODeliveryFee || 0 :
                                            CRVTax > 0 ? order.Tax-CRVTax: order.Tax).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                        {CRVTax > 0 &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                          CRV:
                                          </td>
                                          <td>
                                            {numeral(CRVTax).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                        {SetCoRetailTax && CODeliveryFee > 0 &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            CO Retail Deliver Fee:
                                          </td>
                                          <td>
                                            {numeral(CODeliveryFee).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                      {order.isPOSInvoice &&
                                        <tr>
                                          <td colSpan="3" align="right">
                                            Tip:
                                          </td>
                                          <td>
                                            {numeral(order.tip).format(
                                              '$0,0.00'
                                            )}
                                          </td>
                                        </tr>}
                                      <tr>
                                        <td colSpan="3" align="right">
                                          Total:
                                        </td>
                                        <td>
                                          {numeral(
                                            order.Subtotal +
                                              order.Tax +
                                              order.Freight -
                                              order.TotalMarkDown
                                          ).format('$0,0.00')}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                              </div>
                            </Collapse>
                            <button
                              className={classNames(
                                'btn btn-primary order-details-btn',
                                order.POID !== activeOrder ? 'collapsed' : ''
                              )}
                              type="button"
                              onClick={() => toggleOrder(order.POID)}
                            >
                              <span className="default">Details</span>
                              <span className="open">Close</span>
                            </button>
                          </div>
                        );
                      })}
                </div>
              </div>
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    result: user,
    inProgress
  } = state.postLogin.toJS();

  const {
    result: orderHistory,
    inProgress: loadingOrderHistory,
    error: orderHistoryError
  } = state.getOrderHistory.toJS();

  return {
    user,
    inProgress,
    orderHistory,
    loading: loadingOrderHistory,
    error: orderHistoryError
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getOrderHistory: fetchDux.getOrderHistory.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(MyOrders);
